
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M8.12014 19.3C8.51014 19.69 9.14014 19.69 9.53014 19.3L12.0001 16.83L14.4701 19.3C14.8601 19.69 15.4901 19.69 15.8801 19.3C16.2701 18.91 16.2701 18.28 15.8801 17.89L12.7101 14.72C12.3201 14.33 11.6901 14.33 11.3001 14.72L8.13014 17.89C7.73014 18.27 7.73014 18.91 8.12014 19.3ZM15.8801 4.69997C15.4901 4.30997 14.8601 4.30997 14.4701 4.69997L12.0001 7.16997L9.53014 4.69997C9.14014 4.30997 8.51014 4.30997 8.12014 4.69997C7.73014 5.08997 7.73014 5.72997 8.12014 6.11997L11.2901 9.28997C11.6801 9.67997 12.3101 9.67997 12.7001 9.28997L15.8701 6.11997C16.2701 5.72997 16.2701 5.08997 15.8801 4.69997Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-unfold-less`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconUnfoldLess

    ```js
    <b-new-b-icon-unfold-less />
    ```
</docs>


